import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    TextInput, Button, Checkbox, RadioButtonGroup, FormGroup, RadioButton, ComposedModal, ModalHeader, ModalBody, ModalFooter, TextArea
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { ComboBox } from '../../helpers/ComboBox'
import { FindGHRSEmployer } from '../common/FindGHRSEmployer'
import { showNotification } from '../../helpers/notification/BaseNotification';
import { DateFormat, entitiesLabels } from '../../helpers/Constants';


export default class ModalTrainer extends Component {
    initModalTrainer = (props) => {

        if (props.isEditModal) {
            return { ...props.editModel };
        }

        return {
            id: null, //guid
            type: null,//''//Internal - External //required
            name: null,//''
            surname: null,//''
            email: null,//''
            title: null,//''
            /* position: null,//RITM0984969*/
            badgeNumber: null,//'' //Employer da GHRS oppure Company per (SUB) CONTRACTOR
            organization: null,//''//Name of Organization (if external) Richiesto solo se Trainer=External
            idEmployer: null,
            leadTrainer: null, // bool? //RITM0984969
            //signatureAttachment:null, solo in edit
        }
    }

    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            model: {
                ...this.initModalTrainer(props)
            },
            mode: props.mode || 0,
            appType: ['Internal', 'External'],
        };
    }

    updateState = (inputName, inputValue, objName) => {
        let statusCopy = Object.assign({}, this.state.model);
        if (objName && objName != "model")
            statusCopy[objName][inputName] = inputValue;
        else
            statusCopy[inputName] = inputValue;

        this.setState({ model: statusCopy }, () => {
            if (inputName == "type") {
                if (statusCopy.idEmployer) {
                    this.clear();
                }
            }
        });
    }


    handleChangeModel = (el) => {
        let inputName = el.target.name;
        let inputValue = el.target.value;
        let objName = el.target.alt;

        this.updateState(inputName, inputValue, objName);
    }

    handleChangeRadio = (value, id, event) => {
        if (value == "true") {
            value = true;
        } else
            if (value == "false") {
                value = false;
            } else if (value == "null") {
                value = null;
            }

        this.updateState(id, value, event.target.alt);
    }

    handleChangeCombo = (inputName, selectedItem, objName) => {
        let inputValue = selectedItem ? selectedItem.id : null;
        this.updateState(inputName, inputValue, objName)
    }

    handleChangeComboName = (inputName, selectedItem, objName) => {
        if (selectedItem != null) {
            selectedItem.id = selectedItem.name;
        }
        this.handleChangeCombo(inputName, selectedItem, objName);
    }

    handleChangeMode = (m) => {

        let statusCopy = Object.assign({}, this.state.model);
        if (m == 1) {
            statusCopy.type = this.state.appType[0];
        }
        else statusCopy.type = this.state.appType[1];
        // this.setState({ mode: m })
        this.setState({ model: statusCopy, mode: m });
    }

    setEmployer = (employer) => {
        if (employer && employer.id) {
            let statusCopy = Object.assign({}, this.state.model);
            statusCopy.idEmployer = employer.id;
            statusCopy.badgeNumber = employer.ghrS_ID;
            statusCopy.name = employer.name;
            statusCopy.surname = employer.surname;
            statusCopy.email = employer.email;
            statusCopy.type = this.state.appType[0];
            // statusCopy.position = employer.role;//RITM0984969
            statusCopy.organization = "Saipem";//RITM0984969
            this.setState({ model: statusCopy, mode: 2 });
        }
    }

    save = () => {
        if (this.validator.allValid()) {
            let dati = this.state.model;
            let trainerBadgeFound = dati.badgeNumber != null && dati.badgeNumber?.trim() != '' && this.props.trainers.find((el) => el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase()) ? true : ((dati.badgeNumber == null || dati.badgeNumber?.trim() == '' && this.props.trainers.find((el) => el.id == dati.id && el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase())) ? true : false);
            let trainerNameFound = this.props.trainers.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == dati.name.toLowerCase() + ' ' + dati.surname.toLowerCase()) && el.type == dati.type) ? true : false;
            
            let trainerFoundInParticipant = (dati.badgeNumber != null && dati.badgeNumber?.trim() != '' && this.props.trainingParticipant.find(((el) => el.badgeNumber?.toLowerCase() == dati.badgeNumber?.toLowerCase())) ? true : ((dati.badgeNumber == null || dati.badgeNumber?.trim() == '') && this.props.trainingParticipant.find((el) => (el.name.toLowerCase() + ' ' + el.surname.toLowerCase() == dati.name.toLowerCase() + ' ' + dati.surname.toLowerCase())) ? true : false));
            if (!this.props.isEditModal && trainerBadgeFound && trainerNameFound) { 
                showNotification.warning(`${entitiesLabels.WARNING}`, 'Trainer already present in the training');
                return;
            }
            if (trainerFoundInParticipant) {
                showNotification.warning(`${entitiesLabels.WARNING}`, 'Trainer is already present in the training as participant');
                return;
            }
           
            try {

                this.props.save(dati);
                showNotification.success(`${entitiesLabels.SUCCESS}`, "Trainer created successfully");
            } catch (error) {
                console.error(error);
            }
        } else {
            this.validator.showMessages();
            showNotification.warning(`${entitiesLabels.WARNING}`, + entitiesLabels.TRAINER + " required fields are missing  ");
            this.forceUpdate();
        }
    }

    clear = () => {
        let id = this.state.model.id;
        this.setState({
            model: {
                ...this.initModalTrainer({ isEditModal: false }),
                id: id,
            }
        });
    }

    render() {
        this.validator.purgeFields();
        const validations = {
            type: this.validator.message('type', this.state.model.type, 'required'),
            organization: this.state.model.type == 'External' ? this.validator.message('organization', this.state.model.organization, 'required') : null,
            name: this.validator.message('name', this.state.model.name, 'required'),
            surname: this.validator.message('surname', this.state.model.surname, 'required'),
            //email: this.validator.message('email', this.state.model.email, 'required|email'),
            //  position: this.validator.message('position', this.state.model.position, 'required'), //RITM0984969
        }
        const modalHeader = {
            title: (this.props.isEditModal ? 'Edit ' : 'Add new '),
            iconDescription: 'Close',
            buttonOnClick: () => this.props.toggleModal(false)
        };
        const { title, isOpenModal } = this.props;

        const selectedItemCombo = {
            type: (this.state.appType || []).find(el => el == this.state.model.type),
        };

        return (
            this.state.mode == 1 ?
                <FindGHRSEmployer isOpenModal={isOpenModal} onCancel={this.handleChangeMode} onOk={this.setEmployer} />
                :
                <ComposedModal
                    className="light-modal"
                    open={isOpenModal}
                    danger="false"
                    onClose={() => { return false; }}
                >
                    <ModalHeader className="margin-modal" {...modalHeader} ><p>{title || ''}</p></ModalHeader>
                    <ModalBody className="margin-modal">
                        {
                            this.state.mode == 0 ?
                                <div className="bx--row two-button-center"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "60px"
                                }}                                >
                                    <Button kind="primary" className="bx--col-md-6" style={{
                                        padding: "1rem 1rem",
                                        border: "none",

                                        width: "50px",
                                        fontSize: "20px",
                                        textAlign: "center"
                                    }}
                                        onClick={() => this.handleChangeMode(1)}>Saipem Trainer - INTERNAL
                                        (GHRS Search)</Button>
                                    <Button kind='primary' className="bx--col-md-6" style={{
                                        padding: "1rem 1rem",
                                        border: "none",

                                        width: "60px",
                                        fontSize: "18px",
                                        textAlign: "center"
                                    }}
                                        onClick={() => this.handleChangeMode(2)}>Non Saipem Trainer - EXTERNAL
                                        (Manual Input)</Button>
                                </div>
                                :
                                <div className="bx--grid--full-width">
                                    <div className="bx--row row-content">
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Type*">
                                                <ComboBox
                                                    id="type"
                                                    key={`type${this.state.model.type}`}
                                                    placeholder="Select"
                                                    name="type"
                                                    alt="model"
                                                    onChange={this.updateState}
                                                    itemToString={item => (item ? item : '')}
                                                    initialSelectedItem={selectedItemCombo.type}
                                                    items={this.state.appType}
                                                    disabled={true}
                                                    invalid={validations.type != null}
                                                />
                                                {validations.type}
                                            </FormGroup>
                                        </div>
                                        {this.state.model.type == 'Internal' &&
                                            <div className="bx--col-md-4 bx--col-lg-6">
                                                <FormGroup legendText="Find GHRS*" className="bx--col-md-12 bx--col-lg-12">
                                                    <div className="bx--row two-button-center" >
                                                        <Button kind="primary" className="bx--col" onClick={() => this.handleChangeMode(1)}>GHRS research</Button>
                                                        {/* <Button kind="secondary" className="bx--col" onClick={() => this.clear()}>Clear</Button> */}
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        }
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Name*">
                                                <TextInput
                                                    id="txt-name"
                                                    name="name"
                                                    alt="model"
                                                    placeholder="Input name"
                                                    value={this.state.model.name || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.name != null}
                                                />
                                                {validations.name}
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Surname*">
                                                <TextInput
                                                    id="txt-surname"
                                                    name="surname"
                                                    alt="model"
                                                    placeholder="Input surname"
                                                    value={this.state.model.surname || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                    invalid={validations.surname != null}
                                                />
                                                {validations.surname}
                                            </FormGroup>
                                        </div>

                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            {/*<FormGroup legendText="Email (Personal Email Addresses are not allowed)">*/}
                                            <FormGroup legendText="Professional Mail ID"> {/*RITM0984969*/}
                                                <TextInput
                                                    id="txt-email"
                                                    name="email"
                                                    alt="model"
                                                    placeholder="Input email"
                                                    value={this.state.model.email || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    title="&#9888; Do Not use Personal Accounts"
                                                    disabled={this.state.model.idEmployer != null}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Badge number">
                                                <TextInput
                                                    id="badgeNumber"
                                                    name="badgeNumber"
                                                    alt="model"
                                                    placeholder="Input badge number"
                                                    value={this.state.model.badgeNumber || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                    disabled={this.state.model.idEmployer != null}
                                                //invalid={validations.badgeNumber != null}
                                                />
                                                {/* {validations.badgeNumber} */}
                                            </FormGroup>
                                        </div>
                                        {/* //RITM0984969*/}
                                        {this.state.model.type == 'Internal' &&
                                            <div className="bx--col-md-4 bx--col-lg-6">
                                                <FormGroup legendText="Name of Organization*">
                                                    <TextInput
                                                        id="txt-organization"
                                                        name="organization"
                                                        alt="model"
                                                        placeholder="Input organization"
                                                        value={this.state.model.organization || ''}
                                                        onChange={this.handleChangeModel}
                                                        type="text"
                                                        hideLabel={true}
                                                        labelText=""
                                                        disabled={this.state.model.idEmployer != null}
                                                    />
                                                    {/* {validations.organization}*/}
                                                </FormGroup>
                                            </div>
                                        }
                                        {/*  //RITM0984969*/}
                                        {this.state.model.type == 'External' &&
                                            <div className="bx--col-md-4 bx--col-lg-6">
                                                <FormGroup legendText="Name of Organization*">
                                                    <TextInput
                                                        id="txt-organization"
                                                        name="organization"
                                                        alt="model"
                                                        placeholder="Input organization"
                                                        value={this.state.model.organization || ''}
                                                        onChange={this.handleChangeModel}
                                                        type="text"
                                                        hideLabel={true}
                                                        labelText=""
                                                        invalid={validations.organization != null}
                                                    />
                                                    {validations.organization}
                                                </FormGroup>
                                            </div>
                                        }
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Title">
                                                <TextInput
                                                    id="txt-title"
                                                    name="title"
                                                    alt="model"
                                                    placeholder="Input title"
                                                    value={this.state.model.title || ''}
                                                    onChange={this.handleChangeModel}
                                                    type="text"
                                                    hideLabel={true}
                                                    labelText=""
                                                />

                                            </FormGroup>
                                        </div>
                                        {/*  RITM0984969*/}
                                        <div className="bx--col-md-4 bx--col-lg-6">
                                            <FormGroup legendText="Lead Trainer ">
                                                <Checkbox
                                                    id="leadTrainer"
                                                    alt="model"
                                                    labelText=""
                                                    checked={
                                                        this.state.model.leadTrainer || false
                                                    }
                                                    onChange={(value, id) =>
                                                        this.updateState(id, value, "model")
                                                    }
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </div>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>Cancel</Button>
                        <Button kind='primary' onClick={() => this.save()}>Save</Button>
                    </ModalFooter>
                </ComposedModal>
        );
    }
}
